import api from "../api/apiClient";
import { AuthStore } from "../stores/AuthStore";
import { UserResponseSchema, type UserResponse } from "@/models/core/user";

export interface SuperAdminLoginInput {
  email: string;
  password: string;
}

export async function loginSuperAdmin(input: SuperAdminLoginInput): Promise<UserResponse> {
  const raw = await api.post("/auth/admin/login", {
    email: input.email,
    password: input.password,
  });

  const { user, accessToken, refreshToken } = raw.data.data as {
    user: Record<string, unknown>;
    accessToken: string;
    refreshToken: string;
  };

  if (user.userType !== "super_admin") {
    throw new Error("Access denied. Super admin credentials required.");
  }

  const parsed = UserResponseSchema.parse({
    _id: user.id ?? user._id,
    email: user.email,
    name: user.name,
    role: "super_admin",
    userType: "super_admin",
    status: "active",
    emailVerified: true,
    loginAttempts: 0,
    twoFactorEnabled: false,
    avatarUrl: user.avatarUrl ?? `https://api.dicebear.com/7.x/initials/svg?seed=SA`,
  });

  AuthStore.getState().login(true, "super_admin", parsed, accessToken, refreshToken);
  return parsed;
}

export function logoutSuperAdmin(): void {
  AuthStore.getState().logout();
}
